import Vue from 'vue'
import VueRouter from 'vue-router'

//引入页面
import login from '../views/login/login.vue'
import notFound from '../views/notFound/notFound.vue'
import photo from '../views/photo/photo.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'login',
		component: login,
		meta: {
			title: '欢迎登录-河北省司法鉴定委托受理案件管理系统'
		}
	},
	{
		path: '/photo',
		name: 'photo',
		component: photo,
		meta: {
			title: '活体检测-河北省司法鉴定委托受理案件管理系统'
		}
	},
	{
		path: '/notFound',
		name: 'notFound',
		component: notFound,
		meta: {
			title: '河北省司法鉴定委托受理案件管理系统-页面不存在'
		}
	}
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})


const VueRouterPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(to) {
	return VueRouterPush.call(this, to).catch(err => err)
}

export default router
